export { default as GDMDialog } from './GDMDialog';

export type { GDMDialogComponent, GDMDialogProps } from './GDMDialog.type';
